export default __webpack_public_path__ + "static/media/stars.1ebddf08.svg";